export function validateRecipeSave({ name, rows, servingSize, servingsPer }) {
  if (!name.trim()) return "Enter a formulation name.";
  if (rows.some(row => !row.ingredient_id || !Number.isFinite(Number(row.grams)) || Number(row.grams) <= 0)) {
    return "Every ingredient needs a weight greater than zero. Correct or remove incomplete rows; no ingredients will be silently dropped.";
  }
  if (!rows.some((row) => Number(row.grams) > 0)) {
    return "Enter a weight greater than zero for at least one ingredient.";
  }
  if (!Number.isFinite(Number(servingSize)) || Number(servingSize) <= 0) {
    return "Enter the actual serving size in grams (greater than zero), then save again.";
  }
  if (!Number.isFinite(Number(servingsPer)) || Number(servingsPer) <= 0) {
    return "Servings per container must be greater than zero.";
  }
  return null;
}

export function recipeSaveError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => {
      const field = (item.loc || []).filter((part) => part !== "body").join(" · ").replace(/_/g, " ");
      return `${field || "Formulation"}: ${item.msg || "Check this value"}`;
    });
    if (messages.length) return messages.join("; ");
  }
  return error?.response
    ? "Could not save. Please try again. Your entries are still on this page."
    : "Could not reach the server. Keep this page open, check your connection, and try Save again.";
}
